var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoloFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo Icons"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Box",
    cx: 18,
    cy: 18.543,
    r: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo",
    d: "M25.0055 23.7457L25.8036 18.5424H20.8111V15.1658C20.8111 13.7422 21.5085 12.3547 23.7447 12.3547H26.0146V7.92482C26.0146 7.92482 23.9545 7.57324 21.9851 7.57324C17.8732 7.57324 15.1858 10.0652 15.1858 14.5766V18.5424H10.6152V23.7457H15.1858V36.3244C16.1023 36.4682 17.0416 36.5431 17.9985 36.5431C18.9553 36.5431 19.8947 36.4682 20.8111 36.3244V23.7457H25.0055Z",
    fill: "#0C5393"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoloFb);
export default __webpack_public_path__ + "static/media/lolo_fb.f365c7faaa27a225e3a696018fd14ffc.svg";
export { ForwardRef as ReactComponent };